/* eslint-disable prettier/prettier */
// data.js
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images (default avatar)
import defaultAvatar from "assets/images/team-2.jpg";

// API
import { getClioData } from "apis/api";

export default async function activitiesTableData(filters = {}) {
    const { issuedAfter, issuedBefore } = filters;

    try {
        const response = await getClioData(issuedAfter, issuedBefore, "activities");
        const activitiesData = response;
        // console.log(activitiesData.data);

        const activitiesRows = activitiesData.data.map((bill) => ({
            type: bill?.type || "",
            date: bill?.date || "",
            quantity_in_hours: bill?.quantity_in_hours || "",
            quantity: bill?.quantity,
            price: bill?.price,
            total: bill?.total,
            bill_number: bill?.bill?.number,
            user_name: bill?.user.name || "",
            matter_display_number: bill?.matter?.display_number || "",

            // client_name: bill?.client?.name || "",
            // client_initials: bill?.client?.initials || "",
            // client_type: bill?.client?.type || "",
            // client_etag: bill?.client?.etag || "",
            // responsible_attorney_id: bill?.responsible_attorney?.id,
            // responsible_attorney_etag: bill?.responsible_attorney?.etag || "",
            // responsible_attorney_name: bill?.responsible_attorney?.name || "",
            // originating_attorney_id: bill?.originating_attorney?.id || 0,
            // originating_attorney_etag: bill?.originating_attorney?.etag || "",
            // originating_attorney_name: bill?.originating_attorney?.name || "",
        }));

        const activitiesColumns = [
            { Header: "type", accessor: "type", align: "center" },
            { Header: "date", accessor: "date", align: "center" },
            { Header: "quantity_in_hours", accessor: "quantity_in_hours", align: "center" },
            { Header: "quantity", accessor: "quantity", align: "center" },
            { Header: "price", accessor: "price", align: "center" },
            { Header: "total", accessor: "total", align: "center" },
            { Header: "bill_number", accessor: "bill_number", align: "center" },
            { Header: "user_name", accessor: "user_name", align: "center" },
            { Header: "matter_display_number", accessor: "matter_display_number", align: "center" },

        ];

        return { activitiesColumns, activitiesRows, activitiesData };
    } catch (error) {
        console.error("Error in activitiesTableData:", error);
        return { activitiesRows: [], activitiesColumns: [], activitiesData: [] };
    }
}
